import React, { Component } from 'react';

class NotFound extends Component {
    render(){
        return (<p>Not found!</p>);
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/notfound/NotFound.js